"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _makeStyles = _interopRequireDefault(require("@material-ui/styles/makeStyles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const styles = (0, _makeStyles.default)(theme => ({
  timeButton: {
    borderRadius: 48,
    border: "1px solid " + theme.palette.text.secondary,
    color: theme.palette.text.secondary,
    cursor: "pointer",
    letterSpacing: "1.6px",
    fontWeight: 700,
    display: "flex",
    gap: theme.spacing(1.5),
    height: 48,
    position: "relative",
    minWidth: 176,
    "& > div": {
      left: 24,
      position: "absolute",
      top: 12
    },
    "& input": {
      background: "none",
      border: "none",
      color: theme.palette.text.secondary,
      fontFamily: "inherit",
      fontSize: 16,
      fontWeight: 700,
      letterSpacing: "1.6px",
      outline: "none",
      width: "auto",
      "&::-webkit-calendar-picker-indicator": {
        display: "none !important"
      },
      "&:focus-visible": {
        outline: "none !important"
      }
    },
    "& label": {
      fontSize: 16,
      lineHeight: 1,
      textTransform: "uppercase"
    }
  },
  timeButtonWrapper: {
    alignItems: "center",
    display: "flex",
    justifyContent: "flex-start",
    gap: theme.spacing(1),
    padding: theme.spacing(1, 3, 1, 7.5),
    position: "relative",
    height: "100%",
    width: "100%"
  }
}));
var _default = exports.default = styles;